function capitalizeFirstLetter(string) {
  if (!string) return;
  // eslint-disable-next-line consistent-return
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default capitalizeFirstLetter;
